import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'trunk',
      d: 'M-4,-3h1.5v1h-1.5zM1.5,-3h0.5v0.5h-0.5zM2,-2.5h0.5v0.5h-0.5zM-5,-2h0.5v0.5h-0.5zM-3.5,-2h1v0.5h-1zM3.5,-2h1.5v0.5h-1.5zM-5.5,-1.5h1v1h-1zM4.5,-1.5h1v0.5h-1zM0.5,-1h1v0.5h-1zM4.5,-1h1.5v1h-1.5zM-5.5,-0.5h0.5v0.5h-0.5zM-4.5,-0.5h1v0.5h-1zM-5.5,0h1v0.5h-1zM-3.5,0h0.5v0.5h-0.5zM3,0h2.5v0.5h-2.5zM-5,0.5h0.5v0.5h-0.5zM-3,0.5h2v0.5h-2zM4.5,0.5h1v0.5h-1zM-5,1h1.5v0.5h-1.5zM0,1h1.5v0.5h-1.5zM3.5,1h2v0.5h-2zM-3,1.5h3.5v0.5h-3.5zM1.5,1.5h2.5v0.5h-2.5zM-0.5,2h1.5v0.5h-1.5z',
    },
    {
      paint: 'shadow',
      d: 'M2,-2h0.5v0.5h-0.5zM-1,-1.5h1v0.5h-1zM2,-1.5h2.5v0.5h-2.5zM-2,-1h2.5v0.5h-2.5zM1.5,-1h3v0.5h-3zM-3.5,-0.5h7v0.5h-7z',
    },
    {
      paint: 'epicJade',
      d: 'M4,-6h0.5v0.5h-0.5zM3.5,-5.5h2v0.5h-2zM3,-5h3v0.5h-3zM-1,-4.5h0.5v0.5h-0.5zM3,-4.5h2v0.5h-2zM5.5,-4.5h0.5v0.5h-0.5zM-3.5,-4h2.5v0.5h-2.5zM0.5,-4h0.5v0.5h-0.5zM1.5,-4h1v0.5h-1zM3,-4h3v0.5h-3zM-4,-3.5h2v0.5h-2zM-1.5,-3.5h0.5v0.5h-0.5zM0.5,-3.5h4v0.5h-4zM-4.5,-3h0.5v0.5h-0.5zM2,-3h2.5v0.5h-2.5zM-5,-2.5h1v0.5h-1zM2.5,-2.5h2v0.5h-2zM-4.5,-2h1v0.5h-1zM3,-2h0.5v0.5h-0.5zM-4.5,-1.5h1.5v0.5h-1.5zM-4.5,-1h2.5v0.5h-2.5z',
    },
    {
      paint: 'leaf',
      d: 'M-0.5,-6.5h0.5v0.5h-0.5zM-0.5,-6h2.5v0.5h-2.5zM-1,-5.5h1.5v0.5h-1.5zM1,-5.5h1v0.5h-1zM2.5,-5.5h0.5v0.5h-0.5zM-0.5,-5h3.5v0.5h-3.5zM0,-4.5h3v0.5h-3zM1,-4h0.5v0.5h-0.5zM2.5,-4h0.5v0.5h-0.5z',
    },
    {
      paint: 'bushDark',
      d: 'M0,-6.5h0.5v0.5h-0.5zM2,-6.5h0.5v1.5h-0.5zM0.5,-5.5h0.5v0.5h-0.5zM5,-4.5h0.5v0.5h-0.5zM-1,-2h1v0.5h-1zM2.5,-2h0.5v0.5h-0.5zM-3,-1.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'epicGold',
      d: 'M3.5,-6.5h0.5v1h-0.5zM4.5,-6h1v0.5h-1zM-2,-3.5h0.5v0.5h-0.5zM-2.5,-3h1.5v0.5h-1.5zM0.5,-3h1v0.5h-1zM-2,-2.5h1v0.5h-1zM1,-2.5h1v0.5h-1zM-2.5,-2h1.5v1h-1.5zM0,-2h2v1h-2z',
    },
    { paint: 'epicCrystal', d: 'M-0.5,-4.5h0.5v0.5h-0.5zM-1,-4h1.5v2h-1.5z' },
    { paint: 'snowCap', d: 'M-2.5,-2.5h0.5v0.5h-0.5zM0.5,-2.5h0.5v0.5h-0.5z' },
    {
      paint: 'bareBranch',
      d: 'M-5,-0.5h0.5v0.5h-0.5zM3.5,-0.5h1v0.5h-1zM-4.5,0h1v0.5h-1zM-3,0h6v0.5h-6zM-4.5,0.5h1.5v0.5h-1.5zM-1,0.5h5.5v0.5h-5.5zM-3.5,1h3.5v0.5h-3.5zM1.5,1h2v0.5h-2zM-3.5,1.5h0.5v0.5h-0.5zM0.5,1.5h1v0.5h-1z',
    },
  ],
  pixels: 296,
};
export const sprites: readonly PixelSprite[] = [variant0];
